module.exports = __webpack_public_path__ + "static/media/CTLI_9-235w.c0e4f36d.webp";